const paymentInfo = {
    namespaced: true,
    state : {
        paymentList : []
    },
    getters: {
        getPaymentList (state) {
            return state.paymentList
        }
    },
    mutations: {
        setPaymentList (state, payload) {
            state.paymentList = payload
        },    
    },
    actions: {
        setPaymentList ({commit}, payload) {
            commit('setPaymentList', payload)
        },
    }
}

export default paymentInfo